import styled from 'styled-components';
//
import Layout from '../../components/Layout';
import { useEffect, useState } from 'react';
import { getCMS } from '../../api/services/systemService';
import { Title } from '../../components/ui';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5rem 0;
  gap: 2%;
  width: 100%;
  max-width: 100%;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
`;

export default function AccessibilityPage() {
  useEffect(() => {
    getDbCMS();
  }, []);

  const [content, setContent] = useState({
    title: '',
    contents: '',
  });

  const getDbCMS = async () => {
    const result = await getCMS('42');
    setContent(result.cms);
  };

  return (
    <Layout>
      <Container>
        <Title style={{ marginBottom: '30px' }}>{content.title}</Title>
        <TextContainer>
          <div dangerouslySetInnerHTML={{ __html: content.contents }} />
        </TextContainer>
      </Container>
    </Layout>
  );
}
